import { Box, Stack, Typography } from '@mui/material';

import { Link, Logo, Spinner } from '@barboxx/admin-components';
import { useAuth } from '@barboxx/admin-utils';

import { Footer, RootContainer } from '../StyledComponents';
import { LoginForm } from './LoginForm';

export default function Login() {
    const { initializing } = useAuth();

    return (
        <RootContainer maxWidth="xs">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
            >
                <Logo />
                <Typography
                    margin={2}
                    variant="h6"
                    align="center"
                    color="textPrimary"
                >
                    Admin Portal
                </Typography>

                {initializing ? (
                    <Stack height={240} justifyContent="center">
                        <Spinner />
                    </Stack>
                ) : (
                    <LoginForm />
                )}
                <Link
                    sx={theme => ({
                        alignSelf: 'flex-end',
                        marginTop: theme.spacing(1),
                    })}
                    color="textSecondary"
                    to="/forgot-password"
                >
                    Forgot password?
                </Link>
                <Footer>
                    <Typography color="textPrimary" variant="body2">
                        <Link to="/signup">Sign up</Link> for barboxx business
                        portal!
                    </Typography>
                </Footer>
            </Box>
        </RootContainer>
    );
}
